import { __assign as r } from "./_virtual/_tslib.js";
import o, { useImperativeHandle as t } from "react";
import { getInitialOptionsFromProps as n } from "./utils/options.js";
import e from "./hooks/component.js";
import m from "./hooks/common/custom-layer.js";
var i = o.forwardRef(function (o, i) {
  var u = e({
    init: function init(t, e) {
      var m = document.createElement("canvas"),
          i = r(r({}, n(o)), {
        render: function render() {
          return o.render(m, e);
        }
      });
      return new t.CustomLayer(m, i);
    }
  }, o);
  return t(i, function () {
    return u;
  }, [u]), m(u, o), null;
});
export default i;